import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Play, Tv } from 'lucide-react';
import VideoRating from './VideoRating';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LatestVideosWidget = ({ limit = 3, className = '' }) => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    axios.get(`${API}/youtube/videos/latest?limit=${limit}`)
      .then(res => setVideos(res.data))
      .catch(() => {});
  }, [limit]);

  if (videos.length === 0) return null;

  return (
    <Card className={className} data-testid="latest-videos-widget">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-heading flex items-center gap-2">
          <Play className="w-4 h-4 text-red-500" />
          Latest Videos
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {videos.map(video => (
          <div
            key={video.id}
            className="space-y-1"
            data-testid={`widget-video-${video.youtube_video_id}`}
          >
            <a
              href={video.video_url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex gap-3 group"
            >
              <div className="relative w-28 flex-shrink-0 aspect-video rounded overflow-hidden bg-muted">
                <img
                  src={video.thumbnail_url}
                  alt={video.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all flex items-center justify-center">
                  <Play className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity fill-white" />
                </div>
                {video.duration && (
                  <span className="absolute bottom-0.5 right-0.5 bg-black/80 text-white text-[10px] px-1 rounded">
                    {video.duration}
                  </span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium line-clamp-2 group-hover:text-primary transition-colors">
                  {video.title}
                </p>
                <p className="text-[10px] text-muted-foreground mt-1 flex items-center gap-1">
                  <Tv className="w-2.5 h-2.5" />
                  {video.channel_name}
                </p>
              </div>
            </a>
            <div className="flex justify-end -mt-1">
              <VideoRating
                videoId={video.id}
                likes={video.likes || 0}
                dislikes={video.dislikes || 0}
                compact
              />
            </div>
          </div>
        ))}
        <Link
          to="/videos"
          className="text-xs text-primary hover:underline block text-center pt-1"
        >
          View all videos
        </Link>
      </CardContent>
    </Card>
  );
};

export default LatestVideosWidget;
